const filePath = process.env.publicPath ?? ''
const preloginFile = 'register-config.json'
const postloginFile = 'postlogin-react-router.json'
const getRegisterMFEList = async (isLogin = false) => {
	const fileName = isLogin ? postloginFile : preloginFile
	const datetime = new Date().getTime()
	const response = await fetch(`${filePath}/${fileName}?t=${datetime}`, { method: 'GET' })
	const data = await response.json()
	return data
}

const getFullRegisterMFEList = async ()=>{
	const loginApps = await getRegisterMFEList();
	const postLoginApps = await getRegisterMFEList(true);
	return { ...loginApps, ...postLoginApps };

}

const mfeAPI = {
	getRegisterMFEList,
	getFullRegisterMFEList
}

export default mfeAPI
